export const VALID_POSTCODE_LENGTH = 5;
